import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import { Grid } from "@mui/material";
import { useContext, useEffect } from "react";
import { ProviderProjectDashboard } from "../ProjectSupportDashboard";

const ProjectPieChartUnit = () => {

    const {
        lstProjectUnitChart,
    } = useContext(ProviderProjectDashboard);

    useEffect(() => {
        PieChart();
    }, [lstProjectUnitChart])


    const PieChart = () => {
        am4core.addLicense("CH208466903"); //รหัสรายเส้นใช้ไม่ให้ขึ้นเส้นโลโก้

        // Create chart instance
        let chart = am4core.create("chartdiv1", am4charts.PieChart);

        const arrData = lstProjectUnitChart.map((item) => {
            let resultData = {
                "sUnitName": item.sUnitName,
                "nProjectTotal": item.nProjectTotal,
            };
            return resultData;
        });
        chart.data = arrData

        // Add and configure Series
        let pieSeries = chart.series.push(new am4charts.PieSeries());
        pieSeries.dataFields.value = "nProjectTotal";
        pieSeries.dataFields.category = "sUnitName";
        pieSeries.slices.template.strokeWidth = 2;
        pieSeries.slices.template.strokeOpacity = 1;
        pieSeries.ticks.template.disabled = true;
        pieSeries.labels.template.disabled = true;
        pieSeries.slices.template.tooltipText = "{category}: {value} ({value.percent.formatNumber('#.00')}%)";
        pieSeries.tooltip.label.maxWidth = 500;
        pieSeries.tooltip.label.wrap = true;

        // This creates initial animation
        pieSeries.hiddenState.properties.opacity = 1;
        pieSeries.hiddenState.properties.endAngle = -90;
        pieSeries.hiddenState.properties.startAngle = -90;

        chart.hiddenState.properties.radius = am4core.percent(0);
        chart.legend = new am4charts.Legend();
        chart.legend.position = "right";
        chart.legend.scrollable = true;
    }
    return (
        <>

            <Grid item xs={12} md={12}>
                <div id="chartdiv1" style={{ width: "100%", height: "450px" }}></div>
            </Grid>
        </>
    )
}
export default ProjectPieChartUnit